import { render, staticRenderFns } from "./MainDrawer.vue?vue&type=template&id=463f5008&"
import script from "./MainDrawer.vue?vue&type=script&lang=js&"
export * from "./MainDrawer.vue?vue&type=script&lang=js&"
import style0 from "./MainDrawer.vue?vue&type=style&index=0&id=463f5008&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports